module.exports = __webpack_public_path__ + "static/media/pdfpng.f0e1c8b6.png";